export { default } from "./ActivitiesIcon";
